import { render, staticRenderFns } from "./MyProfileAccountTab.vue?vue&type=template&id=af7405e8&scoped=true&"
import script from "./MyProfileAccountTab.vue?vue&type=script&lang=js&"
export * from "./MyProfileAccountTab.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileAccountTab.vue?vue&type=style&index=0&id=af7405e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7405e8",
  null
  
)

export default component.exports